import { MarkedByEnum, QuestionTypeEnum } from '@doltech/utils/lib/constants';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import matchingQuestionMappingHelper from '../../helper/matchingQuestionMapping.helper';
import {
  MatchingHeadingResultExtraQuestionProps,
  ResultMatchingHeadingQuestionInstance,
} from '../../model/Question/result-matching-heading-question.store';
import { MatchingQuestionResult } from './MatchingQuestionResult';

interface MatchingHeadingQuestionResultProps {
  data: ResultMatchingHeadingQuestionInstance & MatchingHeadingResultExtraQuestionProps;
  markedBy: MarkedByEnum;
  questionsInGroup?: any[];
}

export const MatchingHeadingQuestionResult = observer(
  (props: MatchingHeadingQuestionResultProps) => {
    const { data, markedBy, ...rest } = props;

    const { correct, wrong, headerTitle, no, markedStatus } = matchingQuestionMappingHelper(
      QuestionTypeEnum.MATCHING_HEADING,
      data,
      markedBy
    );

    return (
      <MatchingQuestionResult
        key={no}
        correct={correct}
        wrong={wrong}
        headerTitle={headerTitle}
        no={no}
        markedStatus={markedStatus}
        {...rest}
      />
    );
  }
);
